import React from 'react';
import PropTypes from 'prop-types';

const CsvButton = ({ disabled, text = 'Export CSV', onClick, ...props }) => (
	<button 
		className="btn btn-primary" 
		style={{ height: '35px', width: '150px' }}
		disabled={disabled}
		onClick={e => onClick(props, e)}>
		{text}
	</button>
);


CsvButton.propTypes = {
	disabled: PropTypes.bool,
	text: PropTypes.string,
	onClick: PropTypes.func.isRequired,
};

export default CsvButton;
